import { render, staticRenderFns } from "./fucSuggestPage.vue?vue&type=template&id=7339d66c"
import script from "./fucSuggestPage.vue?vue&type=script&lang=js"
export * from "./fucSuggestPage.vue?vue&type=script&lang=js"
import style0 from "./fucSuggestPage.vue?vue&type=style&index=0&id=7339d66c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports